import {FeeScheduleDoctorDataModel} from '../fee-schedule/fee-schedule-doctor.model';

export class FeeScheduleDoctorDataARModel extends FeeScheduleDoctorDataModel {

}
